import request from '@/plugins/axios'

// 查询角色分页
export function rolePage(data) {
    return request({
        url: '/sys/role/page',
        method: 'post',
        data: data
    })
}

// 查询角色列表
export function roleList(data) {
    return request({
        url: '/sys/role/list',
        method: 'post',
        data: data
    })
}

// 查询角色列表
export function roleListByUserId(userId) {
    const data = {
        userId : userId
    };
    return request({
        url: '/sys/role/roleListByUserId',
        method: 'post',
        data: data
    })
}

// 查询角色详细
export function roleDetail(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/role/detail',
        method: 'post',
        data
    })
}

// 查询角色树结构
export function roleTree(data) {
    return request({
        url: '/sys/role/tree',
        method: 'post',
        data
    })
}

// 查询角色下拉树结构
export function roleTreeSelect() {
    return request({
        url: '/sys/role/treeSelect',
        method: 'post'
    })
}

// 根据角色ID查询角色下拉树结构
export function treeByRolMenu(roleId) {
    const data = {
        roleId : roleId
    };
    return request({
        url: '/sys/role/treeByRolMenu/',
        method: 'post',
        data
    })
}

// 查询角色列表（排除节点）
export function roleListExclude(id) {
    const data = {
        id : id
    };
    return request({
        url: '/sys/role/list/exclude/',
        method: 'post',
        data
    })
}

// 新增角色
export function roleAdd(data) {
    return request({
        url: '/sys/role/add',
        method: 'post',
        data: data
    })
}

// 修改角色
export function roleUpdate(data) {
    return request({
        url: '/sys/role/update',
        method: 'post',
        data: data
    })
}

// 删除角色
export function roleDelete(id) {
    const data = {
        id: id
    };
    return request({
        url: '/sys/role/delete/',
        method: 'post',
        data
    })
}

// 修改数据权限
export function dataScope(data) {
    return request({
        url: '/sys/role/dataScope',
        method: 'post',
        data: data
    })
}
